import React, { useState } from "react";
import { CFormText, CInput } from "@coreui/react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { useSelector } from "react-redux";
import { setSelected } from "../redux/notificationsSagas";
import { useDispatch } from "react-redux";
import QuillWrapper from "../../../../components/quillWrapper/QuillWrapper";
import "react-datetime/css/react-datetime.css";

import Schedule from "./Schedule";

export const Filters = () => {
  const dispatch = useDispatch();
  const {
    selected: { all_organizations: all, organization_ids, published, message, title, archived },
    currentUser: { organizations: allOrganizations }
  } = useSelector((state) => state.notifications);
  const [touched, setTouched] = useState(false);

  const getIds = (orgs) => {
    return orgs.map((org) => org.id);
  };

  const selectedOrganizations = allOrganizations.filter((org) => {
    return organization_ids.includes(org.id);
  });

  const onClickAll = (isActive) => {
    dispatch(setSelected({ all_organizations: isActive }));

    if (isActive) {
      dispatch(setSelected({ organization_ids: getIds(allOrganizations) }));
    } else {
      dispatch(setSelected({ organization_ids: [] }));
    }
  };

  const onClickPublish = (isActive) => {
    dispatch(setSelected({ published: isActive, archived: false }));
  };

  const onClickArchived = (isActive) => {
    dispatch(setSelected({ archived: isActive, published: false }));
  };

  const onChange = (message) => {
    dispatch(setSelected({ message }));
  };

  const onOrganizationChange = (orgs) => {
    dispatch(setSelected({ organization_ids: getIds(orgs) }));
    if (orgs.length === allOrganizations.length) {
      dispatch(setSelected({ all_organizations: true }));
    } else {
      dispatch(setSelected({ all_organizations: false }));
    }
  };

  const titleChange = (title) => {
    dispatch(setSelected({ title: title }));
  };

  return (
    <>
      <div className="notifications__section">
        <div className="switch">
          <p className="switch__title">Send to all organizations</p>
          <div className={`switch__content ${all ? "switch__content--active" : ""}`}>
            <ToggleableButton isRadio title="Orgs" isActive={all} onClick={onClickAll} />
          </div>
        </div>

        <div className="switch">
          <p className="switch__title">Publish</p>
          <div className={`switch__content ${published ? "switch__content--active" : ""}`}>
            <ToggleableButton
              isRadio
              title="Publish"
              isActive={published}
              onClick={onClickPublish}
            />
          </div>
        </div>

        <div className="switch">
          <p className="switch__title">Move to archive</p>
          <div className={`switch__content ${archived ? "switch__content--active" : ""}`}>
            <ToggleableButton
              isRadio
              title="Archived"
              isActive={archived}
              onClick={onClickArchived}
            />
          </div>
        </div>
      </div>

      <div className="notifications__section light">
        <div className="notifications__section__el">
          <p>Organizations</p>
          <Dropdown
            height={275}
            haveOnSelectChange
            placeholder="Select Organizations"
            options={allOrganizations}
            selectedFilters={selectedOrganizations}
            enableOnly
            includeSelectAll
            numberDisplayed={3}
            onSelectChange={(data) => onOrganizationChange(data)}
          />
          <CFormText className="help-block">
            {selectedOrganizations.length == 0 ? "Please choose at least 1 organization" : ""}
          </CFormText>
        </div>

        <div className="notifications__section__el">
          <p>Title</p>
          <CInput
            onChange={(e) => titleChange(e.target.value)}
            className="text-input"
            type="text"
            placeholder="Add Notification Title"
            value={title}
          />
          <CFormText className="help-block">
            {title && title.trim()
              ? title.length > 64
                ? "* Text limit is 64 characters"
                : ""
              : "* Please add notification title"}
          </CFormText>
        </div>
      </div>
      <Schedule />
      <div className="notifications__section notifications__section__bottom">
        <QuillWrapper
          value={message}
          onChange={onChange}
          onBlur={() => setTouched(true)}
        />
        <CFormText className="help-block">
          {touched && message.length == 0 ? "Please type notification text" : ""}
        </CFormText>
      </div>
    </>
  );
};
